export const breakpoints = {
  mobile: '480px',
  tablet: '768px',
  desktop: '1240px',
  wide: '1440px',
}
